import { render, staticRenderFns } from "./globalPrivx.vue?vue&type=template&id=a4f6e7b2&"
import script from "./globalPrivx.vue?vue&type=script&lang=js&"
export * from "./globalPrivx.vue?vue&type=script&lang=js&"
import style0 from "./globalPrivx.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports